module.exports = __webpack_public_path__ + "img/puzzle-piece-02.01154216.svg";